import styled, { css } from 'styled-components';

export const Info = styled.div``;

export const Content = styled.div`
  font-size: 13px;
  color: #3e3e3e;
  display: flex;
  align-items: flex-end;
  margin: 2px 0 5px;
  line-height: normal;
  img {
    margin-right: 10px;
  }
  ${props => props.theme === 'dark' && css`
    color: #fff;
  `}
`;
